
import React, { lazy, Suspense, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';

import Select from 'react-select';
import "react-month-picker/css/month-picker.css";
import uuid from 'react-uuid';

import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';

import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import PageLoader from "../common_component/PageLoader.js";

export const ItemVideos = (props) => {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme();

    const [sequenceSelectionList, setSequenceSelectionList] = useState([1]);
    const videoTypeList = ["Internal", "External"];
    const platformList = ["Youtube"]
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [unique_id, setUnique_id] = useState(uuid());
    const [hasProductVideos, setHasProductVideos] = useState(false)
    const [productName, setProductName] = useState("");
    const [inputFields, setInputFields] = useState([{ video_id: uuid(), priority: "", type: "External", platform: "Youtube", source: "" }]);

    var page_name = "item-videos";
    const MAX_SIZE = 4194304;

    const textstyle = {
        paddingTop: '3px',
    };

    const dropzoneStyle = {
        paddingTop: '15px',
    }

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    async function getProductVideos() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-product-videos`, {
            method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "pid": props.match.params.id, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") }
        }
        );
        const body = await response.json();
        if (body.data.length > 0) {
            setSequenceSelectionList(body.data[0].video_info.map((x, i) => { return (i + 1) }));
            setInputFields(body.data[0].video_info)
            setHasProductVideos(true)

        }
    }
    async function getproductname() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/getproductname`, {
            method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "pid": props.match.params.id, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") }
        }
        );
        const body = await response.json();
        if (body.operation === "success") {
            setProductName(body.data[0].product_name);
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getProductVideos();
            let p2 = getproductname();
            Promise.all([p1, p2])
                .then(() => {
                    setstate(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(0);
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    const handleChangeStatus2 = (index, { meta }) => {
        const { name, status } = meta;
        if (status === 'removed') {
            inputFields[index].source = ''
        }
    };

    const handleAddFields = () => {
        if (inputFields.length < 20) {
            const values = [...inputFields];
            values.push({ video_id: uuid(), priority: "", type: "External", platform: "Youtube", source: "" });
            let temp_dropdown = [];
            for (let i = 1; i < (values.length + 1); i++) {
                temp_dropdown.push(i);

            }
            setSequenceSelectionList(temp_dropdown);
            setInputFields(values);
        }
        else {
            swal("Oops!", `You can add maximum ${inputFields.length} videos of a product!`, "error");
        }

    };

    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        let temp_dropdown = [];
        for (let i = 1; i < (values.length + 1); i++) {
            temp_dropdown.push(i);

        }
        setSequenceSelectionList(temp_dropdown);
        setInputFields(values);
    };

    const handleInputChange = (index, name, val, event) => {
        const values = [...inputFields];
        if (name === "file") {
            //values[index].source = values[index].video_id.concat("_", val);
            values[index].source = values[index].type == "External" ? val : `https://cdnstatic.adoerp.com/product_video/${organization_id}/` + unique_id.concat("_", val);
        }
        else {
            if (name === "type" && val == "Internal") {
                values[index]["platform"] = undefined;
            }
            else if (name === "type" && val == "External") {
                values[index]["platform"] = "Youtube";
            }
            values[index][name] = val;
        }

        setInputFields(values);
    };


    const Preview = ({ fileWithMeta: { remove }, meta }) => {
        const { name, percent, status, previewUrl } = meta;
        // console.log(name)
        return (

            <div className="preview-box">
                <img src={previewUrl} style={{ maxHeight: "80px", maxWidth: "80px", borderRadius: "4px", marginRight: "10px" }} />
                <span title={name} className="name">{name.length >= 10 ? name.slice(0, 10) + "...." : name}</span> - <span className="status">{(status === "done") ? "Successfully Uploaded" : status}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span> && <span className="dzu-previewButton remove" onClick={remove} >
                    <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                        <g>
                            <path class="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                        </g>
                    </svg>
                </span>}
                {
                    status === "done" &&
                    <span className="dzu-previewButton remove" onClick={remove} >
                        <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                            <g>
                                <path class="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                            </g>
                        </svg>
                    </span>
                }
            </div>
        )
    }

    const getUploadParams = ({ file }) => {
        console.log(file)
        const body = new FormData();
        body.append('dataFiles', file);
        body.append('user_id', user.email);
        body.append('organization_id', organization_id);
        body.append('unique_id', unique_id);
        body.append('page_name', page_name);

        let headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            "token": getCookie("access_token")
        }

        return { url: `${process.env.REACT_APP_SERVER_URL}/upload-product-videos`, headers, body }
    }


    const findDuplicateOrder = (arr) => arr.some((obj, i) => arr.find((innerObj, j) => i !== j && obj.priority === innerObj.priority));

    const onSubmit = () => {
        for (var i = 0; i < inputFields.length; i++) {
            if (inputFields[i].priority < 0 || inputFields[i].priority > 20) {
                swal("Oops!", "Sequence number should be between 1-20", "error");
                return false;
            }
            else if (inputFields[i].source == '') {
                swal("Oops!", "Select a file for video " + (i + 1), "error");
                return false;
            }
        }
        if (!findDuplicateOrder(inputFields)) {
            let values = {};
            values.user_id = user.email;
            values.organization_id = organization_id;
            values.video_info = inputFields;
            values.product_id = props.match.params.id;
            values.page_name = page_name

            var headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "*/*",
                    "token": getCookie("access_token")
                }
            }
            setMainSubmitButtonState(true);
            const api = hasProductVideos ? "update-product-videos" : "add-product-videos"
            axios.post(`${process.env.REACT_APP_SERVER_URL}/${api}`, values, headers).then((res) => {
                const message = "Videos " + hasProductVideos ? "updated" : "saved" + " successfully!";
                setMainSubmitButtonState(false);
                if (res.data.operation === "success") {
                    swal("Great!", message, "success").then((value) => {
                        window.location.reload();
                    });
                }
                else {
                    swal("Oops!", "Something went wrong!", "error");
                }
            });
        }
        else {
            swal("Oops!", "You can't give same sequence for multiple videos!", "error");
            return false;
        }
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">{productName}</h1>
                </div>
                <div>
                    {state == 1 ?
                        <>

                            <div className="col-xl-12 p-5" >
                                {inputFields.map((inputField, index) => (
                                    <div className="row mb-sm-5 gx-0 container bg-secondary my-2 p-5 rounded align-items-center" key={index}>
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <h5 className="mt-2">Item Video:{index + 1}</h5>
                                            <div class="d-flex align-items-center gap-2 gap-lg-3">
                                                {inputField.source != "" &&
                                                    <button className="btn btn-primary me-2" onClick={() => { window.open(inputField.source, '_blank'); }}>Check Video</button>}
                                                {inputFields.length > 1 ?
                                                    <button
                                                        className="btn font-weight-bold btn-danger btn-icon"
                                                        type="button"
                                                        onClick={() => handleRemoveFields(index)}
                                                    >
                                                        <i className="la la-remove"></i>
                                                    </button>
                                                    : null}
                                            </div>
                                        </div>
                                        <div className="col-md-2 px-1 mb-2" style={textstyle}>
                                            <label className="required fs-5 fw-bold mb-2">Priority:</label>
                                            <Select
                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                options={sequenceSelectionList.map((x) => { return { label: x, value: x } })}
                                                onChange={(val) => { handleInputChange(index, "priority", val.value, val); }}
                                                value={{ label: inputField.priority, value: inputField.priority }}
                                            //placeholder="Select the Sequence of Order"
                                            />
                                        </div>
                                        <div className="col-md-3 px-1 mb-2" style={textstyle}>
                                            <label className="required fs-5 fw-bold mb-2">Type:</label>
                                            <Select
                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                options={videoTypeList.map((x) => { return { label: x, value: x } })}
                                                onChange={(val) => { handleInputChange(index, "type", val.value, val); }}
                                                value={{ label: inputField.type, value: inputField.type }}
                                            //placeholder="Select the Sequence of Order"
                                            />
                                        </div>
                                        {inputField.type == "External" &&
                                            <div className="col-md-3 px-1 mb-2" style={textstyle}>
                                                <label className="required fs-5 fw-bold mb-2">Platform:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={platformList.map((x) => { return { label: x, value: x } })}
                                                    onChange={(val) => { handleInputChange(index, "platform", val.value, val); }}
                                                    value={{ label: inputField.platform, value: inputField.platform }}
                                                //placeholder="Select the Sequence of Order"
                                                />
                                            </div>}
                                        {inputField.type == "External" ?
                                            <div className="col-md-3 px-1 mb-2" style={textstyle}>
                                                <label className="required fs-5 fw-bold mb-2">Source:</label>
                                                <input className="form-control" value={inputField.source} onChange={(e) => { handleInputChange(index, "file", e.target.value, e); }}></input>
                                            </div>
                                            :
                                            <div className="col-xl-5 px-1" style={dropzoneStyle}>
                                                <Dropzone
                                                    //getUploadParams={(file) => {getUploadParams(file,inputField.video_id)}}
                                                    getUploadParams={getUploadParams}
                                                    maxSize={MAX_SIZE}
                                                    onChangeStatus={(event) => {
                                                        handleInputChange(index, "file", event.file.name, event);
                                                        handleChangeStatus2(index, event);
                                                    }}
                                                    maxFiles={1}
                                                    multiple={false}
                                                    styles={{
                                                        dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5', justifyContent: "center" },
                                                        inputLabelWithFiles: { margin: '20px 3%' }
                                                    }}
                                                    PreviewComponent={Preview}
                                                    accept="video/*"
                                                />
                                                <div className="form-text">Video size should be less than 300MB.</div>
                                            </div>}
                                    </div>
                                ))}
                            </div>

                            <div className="form-group row" style={dropzoneStyle}>
                                <div>
                                    <button type="button" className="btn font-weight-bold btn-primary" onClick={() => handleAddFields()}>
                                        <i className="la la-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end">

                                <button onClick={(e) => { onSubmit(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}>
                                    <span className="indicator-label">{hasProductVideos ? <>Update Changes</> : <>Save Changes</>}</span>
                                    <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                                </button>
                            </div>
                        </>
                        :
                        <div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
                            <br />
                            {state == 2 ?
                                <PageLoader />
                                :
                                <PageError />
                            }
                            <br />
                        </div>
                    }
                </div>
            </div>
        </>);

};

export default ItemVideos;
